<template>
    <div>
        <transition name="fade">
            <div v-show="show" ref="imgWrapper" class="img-viewer-wrapper">
                <div class="close" @click="emitChange">×</div>
                <img :src="bolb" alt="" />
                <div class="cover" @click="emitChange"></div>
            </div>
        </transition>
    </div>
</template>

<script>
import gesture from './mixins/gesture'

export default {
    mixins: [gesture],
    model: {
        prop: 'show',
        event: 'change'
    },
    props: {
        show: Boolean,
        bolb: String
    },
    data() {
        return {
            showHint: false
        }
    },
    methods: {
        emitChange() {
            setTimeout(() => {
                this.$emit('change', false)
            }, 150)
        }
    },
    mounted() {
        this.bindEvent()
    },
    computed: {
        el() {
            return this.$refs.imgWrapper.querySelector('img')
        }
    },
    watch: {
        show(v) {
            if (v) {
                this.ResetPdfStyle()
                this.updatePdfElStyle()
            }
        }
    }
}
</script>

<style scoped lang="less">
.img-viewer-wrapper {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    > img {
        display: block;
        position: relative;
        z-index: 10;
        width: 100%;
        object-fit: contain;
    }
}
.cover {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
}
</style>
